import { render, staticRenderFns } from "./batchAttributes.vue?vue&type=template&id=5ce17630&scoped=true&"
import script from "./batchAttributes.vue?vue&type=script&lang=js&"
export * from "./batchAttributes.vue?vue&type=script&lang=js&"
import style0 from "./batchAttributes.vue?vue&type=style&index=0&id=5ce17630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce17630",
  null
  
)

export default component.exports